<template>
  <Header headerShadow="header__area header__padding header__padding-2 header__shadow " />
  <section class="page__title-area pt-90 pb-90">
    <div class="page__title-shape">
      <img class="page-title-shape-5 d-sm-block" src="../assets/img/page-title/page-title-shape-1.png" alt="">
      <img class="page-title-shape-6" src="../assets/img/page-title/page-title-shape-6.png" alt="">
      <img class="page-title-shape-7" src="../assets/img/page-title/page-title-shape-4.png" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="course__wrapper">
            <div class="page__title-content pt-90 mb-25">
              <div class="page__title-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/">{{ $t('actions.home') }}</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">{{ $t('navbar.tuzilma') }}</li>
                  </ol>
                </nav>
              </div>
              <h5 class="page__title-3" style="font-size: 35px">{{ $t('navbar.tuzilma') }}</h5>
            </div>

            <div class="course__tab-content mb-65">
              <div class="tab-content" id="courseTabContent">
                <div class="tab-pane fade show active mb-30" id="description" role="tabpanel" aria-labelledby="description-tab">
                  <div class="course__description">
                    <div class="org-chart">
                      <div class="mt-3 mb-4">
                        <h5 class="page__title-5" style="color: black; font-size: 23px; font-weight: bold; text-align: center">{{ $t('structure.label')}}</h5>
                      </div>
                      <div class="box director mt-2">{{ $t('structure.director')}}</div>
                      <div class="connector"></div>
                      <div class="level">
                        <div class="column1">
                          <div class="connector1"></div>
                          <div class="box1 d-flex align-items-center justify-content-center" style="height: 74px; font-weight: bold">{{ $t('structure.it')}}</div>
                          <div class="box1" style="margin: 35px 0">{{ $t('structure.server')}}</div>
                          <div class="box1">{{ $t('structure.programmer')}}</div>
                        </div>

                        <div class="column2">
                          <div class="connector"></div>
                          <div class="box2" style="font-weight: bold; margin-bottom: 35px">{{ $t('structure.mahallabay')}}</div>
                          <div class="box2">{{ $t('structure.hududMahalla')}}</div>
                          <div class="box2 d-flex align-items-center justify-content-center" style="margin: 35px 0; height: 74px; padding:15px 25px;">{{ $t('structure.tashqiRek')}}</div>
                          <div class="box2">{{ $t('structure.callCenter')}}</div>
                        </div>

                        <div class="column" style="font-weight: bold">
                          <div class="connector1"></div>
                          <div class="box">{{ $t('structure.buglater')}}<span class="number">2</span></div>
                          <div class="connector"></div>
                          <div class="box">{{ $t('structure.hr')}}</div>
                          <div class="connector"></div>
                          <div class="box">{{ $t('structure.pr')}}</div>
                          <div class="connector"></div>
                          <div class="box">{{ $t('structure.mamuriy')}}</div>
                          <div class="connector"></div>
                          <div class="box">{{ $t('structure.yuridik')}}</div>
                          <div class="connector"></div>
                          <div class="box">{{ $t('structure.xalqaro')}}</div>
                          <div class="connector"></div>
                          <div class="box">{{ $t('structure.devonxona')}}</div>
                          <div class="connector"></div>
                          <div class="box">{{ $t('structure.xizmatkorsat')}}</div>
                        </div>
                      </div>

                      <div class="statistics-footer">
                        <h3>{{ $t('structure.xodimSta')}}</h3>
                        <div class="stats-grid">
                          <div class="stat-item">
                            <span class="number1">51</span>
                            <span class="label">{{ $t('structure.xodimSta1')}}</span>
                          </div>
                          <div class="stat-item">
                            <span class="number1">18</span>
                            <span class="label">{{ $t('structure.xodimSta2')}}</span>
                          </div>
                          <div class="stat-item">
                            <span class="number1">32</span>
                            <span class="label">{{ $t('structure.xodimSta3')}}</span>
                          </div>
                          <div class="stat-item">
                            <span class="number1">1</span>
                            <span class="label">{{ $t('structure.xizmatkorsat')}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <Footer footerPadding="true"/>

</template>

<script>
import Header from '../components/HomeTwo/Header.vue';
import Footer from '../components/Home/Footer.vue';
import CourseItemMixin from '../mixins/courseItemsMixin';
// import CourseSidebar from '../components/CourseDetails/CourseSidebar.vue';
import {Swiper, SwiperSlide} from "swiper/vue";
import { Pagination } from "swiper";
import { mapGetters, mapActions } from 'vuex'
import BlogMixin from '@/mixins/blogMixin';
export default {
  name: "CourseDetailsPage",
  components:{
    Swiper,
    SwiperSlide,
    Header,
    // CourseSidebar,
    Footer
  },
  mixins: [CourseItemMixin, BlogMixin],
  data() {
    return {
      course: [
        {
          image: "rahbarr",
          name: "Kichkilov Ravshan Xamzayevich",
          position: "actions.director",
          phone: "71 207 47 00",
          email: "z.egamova@atjem.antimon.gov.uz",
          freeTime: "actions.freeTime",
        },
        {
          image: "rahbar1",
          name: "Ochilov Bahrom Bo'riboyevich",
          position: "actions.zamDirector",
          phone: "71 207 47 00",
          email: "z.egamova@atjem.antimon.gov.uz",
          freeTime: "actions.freeTime1",
        },
        {
          image: "rahbar2",
          name: "Toshqulov Lazizbek Ruslan o'g'li",
          position: "actions.VVBDirector",
          phone: "71 207 47 00",
          email: "z.egamova@atjem.antimon.gov.uz",
          freeTime: "actions.freeTime",
        }
      ],
    }
  },

  created() {}
};
</script>

<style scoped lang="css">
.course__description{
  width: 100%;
  padding: 30px 15px;
  border-radius: 8px;
  box-shadow: 0px 1px 6px rgba(100, 100, 100, 0.1);
}
.circle__image {
  width: 230px;
  height: 230px;
  border-radius: 50%;
  margin: 20px;
  object-fit: cover;
  object-position: center;
  border: 1px solid darkgray;
  padding: 10px;
}

.org-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  color: #090909;
}

.box {
  background: white;
  border: 1px solid black;
  border-radius: 3px;
  padding: 15px 20px;
  text-align: center;
  width: 300px;
  position: relative;
  font-size: 15px;
  color: #2c3e50;
  line-height: 1.4;
  box-shadow: 2px 2px 4px rgba(0,0,0,0.1);
}

.box1 {
  background: white;
  border: 1px solid black;
  border-radius: 3px;
  padding: 15px 20px;
  text-align: center;
  width: 300px;
  position: relative;
  font-size: 15px;
  color: #2c3e50;
  line-height: 1.4;
  box-shadow: 2px 2px 4px rgba(0,0,0,0.1);
}
.box1::before {
  content: '';
  position: absolute;
  top: 50%;
  left: -25px;
  transform: translateY(50%);
  width: 25px;
  height: 1px;
  background-color: #090909 !important;
}

.box2 {
  background: white;
  border: 1px solid black;
  border-radius: 3px;
  padding: 15px;
  text-align: center;
  width: 400px;
  position: relative;
  color: #2c3e50;
  font-size: 15px;
  line-height: 1.4;
  box-shadow: 2px 2px 4px rgba(0,0,0,0.1);
}
.box2::before {
  content: '';
  position: absolute;
  top: 50%;
  left: -20px;
  transform: translateY(50%);
  width: 20px;
  height: 1px;
  background-color: #090909 !important;
}

.box.director {
  font-weight: bold;
  min-width: 250px;
}

.number {
  display: none;
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: 12px;
  color: black;
}

.level {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
  position: relative;
}

.level::before {
  content: '';
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 72.3%;
  height: 1px;
  background: black;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: center;
}


.column1 {
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: center;
  position: relative;
}

.column1::before {
  content: '';
  position: absolute;
  top: 57px;
  left: -25px;
  width: 1px;
  height: 209px;
  background: black;
}

.column2 {
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: center;
  position: relative;
}

.column2::before {
  content: '';
  position: absolute;
  top: 72px;
  left: -20px;
  width: 1px;
  height: 318px;
  background: black;
}

.connector {
  width: 1px;
  height: 35px;
  background: black;
  margin: 0 auto;
}
.connector1 {
  width: 1px;
  height: 20px;
  background: black;
  margin: 0 auto;
}

/* Statistics Footer */
.statistics-footer {
  width: 100%;
  margin-top: 60px;
  padding: 30px;
  background: white;
  border-radius: 12px;
 /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  text-align: center;
}

.statistics-footer h3 {
  color: #2c3e50;
  margin-bottom: 15px;
  font-size: 18px;
}

.stats-grid {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.stat-item {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #424ff9;
  margin: 0 20px;
}

.stat-item .number1 {
  font-size: 28px;
  font-weight: 700;
  color: #424ff9;
  display: block;
}

.stat-item .label {
  font-size: 13px;
  color: #7f8c8d;
  margin-top: 5px;
}
/*@media (max-width: 768px) {
  .level {
    flex-direction: column;
    align-items: center;
  }

  .box {
    min-width: 280px;
  }
}*/

</style>
